export default {
    yes: 'Ναι',
    no: 'Όχι',
    toDo: 'To-Do',
    athletes: 'Πελάτες',
    dietPlan: 'Διατροφικό πλάνο',
    dietPlans: 'Διατροφικά πλάνα',
    loading: 'Φόρτωση',
    viewAll: 'Προβολή όλων',
    options: 'Επιλογές',
    filterByTag: {
        title: 'Φιλτράρισμα ανά ετικέτα'
    },
    tags: 'Ετικέτες',
    add: 'Προσθήκη',
    addTag: 'Προσθήκη ετικέτας',
    existingTag: 'Επιλέξτε μια υπάρχουσα ετικέτα',
    view: 'Προβολή',
    from: 'Από',
    to: 'Έως',
    createdAt: 'Ημερομηνία δημιουργίας',
    updatedAt: 'Τελευταία τροποποίηση',
    dropCsv: 'Σύρτε εδώ ένα αρχείο csv ή πατήστε πάνω στο πλαίσιο',
    dropImg: 'Σύρτε εδώ μια εικόνα ή πατήστε στο πλαίσιο',
    imageTooBig: 'Η εικόνα ξεπερνά το μέγιστο μέγεθος των {size}',
    saveAsPdf: 'Αποθήκευση ως PDF',
    print: 'Εκτύπωση',
    colorPick: 'Επιλογή χρώματος',
    fullName: 'Ονοματεπώνυμο',
    value: 'Τιμή',
    left: 'Α',
    right: 'Δ',
    leg: 'Πόδι',
    hand: 'Χέρι',
    age: {
        years: 'Ετών',
        months: 'Μηνών',
        days: 'Ημερών',
        hours: 'Ωρών'
    },
    optionalField: "{field} (προαιρετικό)",
    preview: 'Προεπισκόπηση',
    uploading: 'Μεταφόρτωση...',
    saving: 'Αποθήκευση...',
    save: 'Αποθήκευση',
    edit: 'Επεξεργασία',
    delete: 'Διαγραφή',
    undo: 'Αναίρεση',
    redo: 'Επαναφορά',
    timezonePrompt: {
        title: 'Ορισμός Timezone',
        description: 'Για να διασφαλιστούν οι σωστές ώρες στο ημερολόγιο και τις προγραμματισμένες δραστηριότητες, παρακαλώ επιλέξτε το timezone σας.'
    },
    timezoneMismatch: {
        title: 'Εντοπίστηκε Αναντιστοιχία Timezone',
        description: 'Το αποθηκευμένο timezone σας δεν ταιριάζει με το timezone του browser σας. Θέλετε να το ενημερώσετε;',
        saved: 'Τρέχον αποθηκευμένο',
        detected: 'Εντοπίστηκε από browser',
        keepCurrent: 'Διατήρηση τρέχοντος',
        switchToDetected: 'Αλλαγή σε εντοπισμένο'
    },
    hour: 'Ώρα',
    hours: 'Ώρες',
    actions: 'Ενέργειες',
    search: 'Αναζήτηση',
    noResults: 'Δεν βρέθηκαν αποτελέσματα'
}
